/**
 * @generated SignedSource<<e4c155aa8fc65ee6b8fdc605d5a4cf8e>>
 * @relayHash b9d6b86279b55e2e3743a4dd0fd9d457
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1a4860a72fdcec0a65e125415cf6c6d65f1b5058c46ac65cbb6fb0e71cdeeeb1

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCapacityQuery } from './ui_jiraCapacityQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCapacityQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "1a4860a72fdcec0a65e125415cf6c6d65f1b5058c46ac65cbb6fb0e71cdeeeb1",
    "metadata": {},
    "name": "ui_jiraCapacityQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
